var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { EntityBubbleImage } from '@shapeable/ui';
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { EntityCircleMenu } from './entity-circle-menu';
var cls = classNames('entity-group-map-marker');
import { Marker } from 'react-map-gl';
import { classNames } from '@shapeable/utils';
export var EntityGroupMapMarkerDefaultProps = {
  size: 48
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n    ", "\n  "], ["\n    \n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n    "])), size, size, size / 2);
  })
});
var BubbleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
var CircleMenuStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n  "], ["\n    width: 100%;\n    height: 100%;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Bubble: styled(EntityBubbleImage)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles),
  CircleMenu: styled(EntityCircleMenu)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), CircleMenuStyles)
};
export var EntityGroupMapMarker = function (props) {
  var className = props.className,
    children = props.children,
    selectedEntity = props.selectedEntity,
    popup = props.popup,
    onSelect = props.onSelect,
    items = props.items,
    rest = __rest(props, ["className", "children", "selectedEntity", "popup", "onSelect", "items"]);
  var size = rest.size;
  if (items.length === 0) {
    return null;
  }
  return React.createElement(Marker, __assign({}, rest, {
    anchor: "bottom"
  }), React.createElement(My.Container, {
    size: size,
    className: cls.name(className)
  }, React.createElement(My.CircleMenu, __assign({
    popup: popup,
    selectedEntity: selectedEntity,
    onSelect: onSelect,
    items: items
  }, rest))));
};
EntityGroupMapMarker.defaultProps = EntityGroupMapMarkerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;